export default "https://cdn-gra.amplement.io/statics/images/browsers/chrome.png";